// --------------------------------------------------------------
// Created On: 2021-09-30
// Author: Zachary Thomas
//
// Last Modified: 2025-10-27
// Modified By: Zachary Thomas
//
// Copyright 2024 - 2025 © Cornell Pump Company, All Rights Reserved
// --------------------------------------------------------------

import React from "react";

// A single user in an user list.
export default function UserListRow(props: Props): Component {
  return (
    <div data-test="user-list-row" className="p-2">
      {props.name} ({props.emailAddress})
    </div>
  );
}

interface Props {
  userId: number;
  name: string;
  emailAddress: string;
}
